import api from '../../../services/api';
import type { Customer, CustomerSubmitValues } from '../types';

export async function createCustomer(payload: CustomerSubmitValues): Promise<Customer> {
  const response = await api.post('/customers', payload);
  return response.data;
}

/** `archived: true` when the customer has orders and was archived instead of deleted. */
export interface CustomerDeleteResult {
  archived?: boolean;
  orderCount?: number;
}

export async function deleteCustomer(customerId: string): Promise<CustomerDeleteResult> {
  const response = await api.delete(`/customers/${customerId}`);
  return response.data || {};
}
